<template>
  <div class="ps-grid" v-show="statData.length">
    <div
      v-for="(stat, index) in statData"
      :key="index"
      class="ps-card"
    >
      <div class="ps-card-top">
        <div class="ps-card-left">
          <div class="ps-label">{{ formatTitle(stat.title) }}</div>
          <div class="ps-value-row">
            <span class="ps-value">{{ stat.value }}</span>
            <span
              v-if="stat.perc && stat.perc !== '0' && stat.title !== 'INSCRITOS'"
              class="ps-pct"
              :style="{ background: colorMap[stat.color].bg, color: colorMap[stat.color].color }"
            >{{ stat.perc }}</span>
          </div>
        </div>
        <div
          class="ps-icon"
          :style="{ background: colorMap[stat.color].bg, color: colorMap[stat.color].color }"
        >
          <i :class="colorMap[stat.color].icon"></i>
        </div>
      </div>
      <div class="ps-bar">
        <div
          class="ps-bar-fill"
          :style="{ width: barWidth(stat) + '%', background: colorMap[stat.color].color }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'

export default {
  data () {
    return {
      timeout: 60000,
      statData: [],
      colorMap: {
        dark: { color: '#495057', bg: '#f1f3f6', icon: 'bx bx-group' },
        purple: { color: '#74788d', bg: '#f1f3f6', icon: 'bx bx-time-five' },
        blue: { color: '#4D8FF2', bg: '#e8f0fe', icon: 'bx bx-loader-alt' },
        orange: { color: '#F26516', bg: '#fef0e6', icon: 'bx bx-error-alt' },
        green: { color: '#01B366', bg: '#e6f7ef', icon: 'bx bx-check-circle' },
        red: { color: '#F51919', bg: '#fee7e7', icon: 'bx bx-x-circle' }
      }
    }
  },
  methods: {
    getSubscribers () {
      http.get('/admin/metrics/participants').then((response) => {
        this.statData = response.data
      }).catch((error) => {
        console.error(error)
      })
    },
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    setValue () {
      this.getSubscribers()
    },
    formatTitle (title) {
      if (!title) return ''
      return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
    },
    barWidth (stat) {
      if (stat.title === 'INSCRITOS') return 100
      const perc = String(stat.perc || '0').replace('%', '')
      return parseFloat(perc) || 0
    }
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  mounted () {
    this.getSubscribers()
    this.timeout = setInterval(() => {
      this.getSubscribers()
    }, 60000)
  }
}
</script>

<style scoped>
.ps-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}
@media (max-width: 1200px) {
  .ps-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 576px) {
  .ps-grid { grid-template-columns: repeat(2, 1fr); }
}

.ps-card {
  background: #fff;
  border: none;
  border-radius: 5px;
  padding: 16px 18px 14px;
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
  cursor: default;
  overflow: hidden;
}
.ps-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.ps-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.ps-card-left {
  min-width: 0;
}
.ps-label {
  font-size: 13px;
  font-weight: 500;
  color: #5b6478;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ps-value-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.ps-value {
  font-size: 26px;
  font-weight: 800;
  color: #1a1d26;
  letter-spacing: -0.5px;
  line-height: 1.2;
}
.ps-pct {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.ps-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.ps-bar {
  height: 4px;
  background: #f1f3f6;
  border-radius: 2px;
  overflow: hidden;
  margin-top: auto;
}
.ps-bar-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
